module.exports = __webpack_public_path__ + "img/brad-neathery-nPy0X4xew60-unsplash.d7dd5397.jpg";